import React, { Fragment, useEffect, useState } from 'react';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';

import o1 from '../../images/orphanage-visit/orphanage-1.webp'
import o2 from '../../images/orphanage-visit/2.webp'
import o3 from '../../images/orphanage-visit/3.webp'
import o4 from '../../images/orphanage-visit/4.webp'
import o5 from '../../images/orphanage-visit/5.webp'
import o7 from '../../images/orphanage-visit/7.webp'
import o8 from '../../images/orphanage-visit/8.webp'
import o9 from '../../images/orphanage-visit/9.webp'
import o10 from '../../images/orphanage-visit/10.webp'

import metadataJSON from "../../data/metadata.json";
import schemadataJSON from "../../data/schemadata.json";
import { Helmet } from 'react-helmet';

const OrphangeVisit = ({ path }) => {
    
    // Setting metadata and schemadata 
    const [metadata, setMetadata] = useState({title: "JJFIndia | Our Initiative"});
    const [schemadata, setSchemadata] = useState({});
    
    // Getting the schemadata and setting the schema data. 
    useEffect(() => {
        let tempMetadata = metadataJSON[path];
        let tempSchemadata = schemadataJSON[path];

        if(tempMetadata){
        setMetadata(tempMetadata);
        }else {
        tempMetadata = {
            title: "JJFIndia | Gallery",
            description: "JJFIndia Gallery page",
            keywords: "",
            robots: "index, follow",
            canonical: "https://jjfindia.com/gallery/tree-plantation",
            openGraph: {
                title: "JJFIndia | Gallery",
                description: "JJFIndia Gallery page",
                url: "https://jjfindia.com/gallery/tree-plantation"
            },
            twitter: {
                card: "summary_large_image",
                title: "JJFIndia | Gallery",
                description: "JJFIndia Gallery page"
            }
        }

        setMetadata(tempMetadata);
        }

        // setting schema data 
        if(tempSchemadata) {
            setSchemadata(tempSchemadata);
        }

    }, [path]);

    return (
        <>

        <Helmet>
            {/* Basic Meta Tags */}
            <title>{metadata.title}</title>
            <meta name="description" content={metadata.description} />
            <meta name="keywords" content={metadata.keywords} />
            <meta name="robots" content={metadata.robots} />
    
            {/* Canonical URL */}
            <link rel="canonical" href={metadata.canonical} />
    
            {/* Open Graph */}
            <meta property="og:title" content={metadata.openGraph?.title} />
            <meta property="og:description" content={metadata.openGraph?.description} />
            <meta property="og:url" content={metadata.canonical} />
    
            {/* Twitter Cards */}
            {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
            <meta name="twitter:title" content={metadata.twitter?.title} />
            <meta name="twitter:description" content={metadata.twitter?.description} />
            
            {/* Setting up schema data */}
            <script  type="application/ld+json" >{JSON.stringify(schemadata, null, 2)}</script>
        </Helmet>

        <Fragment>
            <Header hclass={'header--styleFour'} />
            <main className="page_content">
                <PageTitle pageTitle={'Orphanage Visit'} pagesub={'Gallery'} />

              
                <section className="blog pt-60">
                    <div className="container">
                        <div className="row align-items-end">
                            <div className="col-12">
                                <div className="sectionTitle mb-40" id='feature'>
                                    <span className="sectionTitle__small justify-content-center">
                                        <i className="fa-solid fa-heart btn__icon"></i>Orphanage Visit
                                    </span>
                                    <h1 className="sectionTitle__big text-center">Orphanage Visit</h1>
                                    <p className='text-center' style={{ fontSize: '24px' }}>Heartwarming images from our visits, spreading love and joy to children.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="blogBlock blogBlock--style3 mb-60">
                                    <figure className="blogBlock__figure">
                                        {/* <Link to="#" */}
                                        {/* onClick={(e) => e.preventDefault()} className="blogBlock__figure__link"> */}
                                        <img src={o1} alt="Volunteers interacting with children during an orphanage visit" className="blogBlock__figure__image" />
                                        {/* </Link> */}
                                    </figure>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="blogBlock blogBlock--style3 mb-60">
                                    <figure className="blogBlock__figure">
                                        <img src={o2} alt="Group with children and volunteers at the orphanage." className="blogBlock__figure__image" />
                                    </figure>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="blogBlock blogBlock--style3 mb-60">
                                    <figure className="blogBlock__figure">
                                        <img src={o3} alt="Kids seated on the floor during an activity session at the orphanage." className="blogBlock__figure__image" />
                                    </figure>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="blogBlock blogBlock--style3 mb-60">
                                    <figure className="blogBlock__figure">
                                        <img src={o4} width={400} loading='lazy' alt="Volunteers addressing children during an orphanage program" className="blogBlock__figure__image" />
                                    </figure>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="blogBlock blogBlock--style3 mb-60">
                                    <figure className="blogBlock__figure">
                                        <img src={o5} width={400} loading='lazy' alt="Children participating in an activity during the orphanage visit." className="blogBlock__figure__image" />
                                    </figure>
                                </div>
                            </div>
                            {/* <div className="col-md-4">
                                <div className="blogBlock blogBlock--style3 mb-60">
                                    <figure className="blogBlock__figure">
                                        <img src={o6} alt="Stronger Together" className="blogBlock__figure__image" />
                                    </figure>
                                </div>
                            </div> */}
                            <div className="col-md-4">
                                <div className="blogBlock blogBlock--style3 mb-60">
                                    <figure className="blogBlock__figure">
                                        <img src={o7} width={400} loading='lazy' alt="Volunteers distributing gifts and essentials to orphanage children." className="blogBlock__figure__image" />
                                    </figure>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="blogBlock blogBlock--style3 mb-60">
                                    <figure className="blogBlock__figure">
                                        <img src={o8} width={400} loading='lazy' alt="Volunteers posing with children holding donated items." className="blogBlock__figure__image" />
                                    </figure>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="blogBlock blogBlock--style3 mb-60">
                                    <figure className="blogBlock__figure">
                                        <img src={o9} width={400} loading='lazy' alt="Team handing over gift kits to children at the orphanage." className="blogBlock__figure__image" />
                                    </figure>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="blogBlock blogBlock--style3 mb-60">
                                    <figure className="blogBlock__figure">
                                        <img src={o10} width={400} loading='lazy' alt="volunteers handing gifts to children during the orphanage visit." className="blogBlock__figure__image" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
        </>
    )
};

export default OrphangeVisit;
